import React from 'react';
import { motion } from 'framer-motion';
import { Check, Palette, Image } from 'lucide-react';
import { ExteriorPalette } from '../../types';
interface PaletteSelectorProps {
  palettes: ExteriorPalette[];
  selectedPaletteId: string | null;
  onSelectPalette: (palette: ExteriorPalette) => void;
}
export function PaletteSelector({
  palettes,
  selectedPaletteId,
  onSelectPalette
}: PaletteSelectorProps) {
  return <div data-id="element-85">
      <div className="flex items-center justify-between mb-3" data-id="element-86">
        <h4 className="text-xs font-bold uppercase tracking-wider text-slate-400" data-id="element-87">
          Choose Exterior Palette
        </h4>
        <div className="flex items-center gap-1" data-id="element-88">
          <button className="p-1.5 rounded hover:bg-white/5 text-cyan-400 transition-colors" data-id="element-89">
            <Palette className="w-3.5 h-3.5" data-id="element-90" />
          </button>
          <button className="p-1.5 rounded hover:bg-white/5 text-slate-400 transition-colors" data-id="element-91">
            <Image className="w-3.5 h-3.5" data-id="element-92" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2" data-id="element-93">
        {palettes.map(palette => {
        const isSelected = selectedPaletteId === palette.id;
        return <motion.button key={palette.id} onClick={() => onSelectPalette(palette)} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className={`relative aspect-square rounded-lg overflow-hidden border-2 transition-all ${isSelected ? 'border-cyan-500 ring-2 ring-cyan-500/50' : 'border-white/10 hover:border-white/30'}`} data-id="element-94">
              {/* Color Grid */}
              <div className="grid grid-cols-2 grid-rows-2 w-full h-full" data-id="element-95">
                {palette.colors.map((color, idx) => <div key={idx} style={{
              backgroundColor: color
            }} className="w-full h-full" data-id="element-96" />)}
              </div>

              {/* Selected Checkmark */}
              {isSelected && <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} className="absolute top-1.5 right-1.5 p-1 bg-cyan-500 rounded-full shadow-lg" data-id="element-97">
                  <Check className="w-2.5 h-2.5 text-white" data-id="element-98" />
                </motion.div>}

              {/* Label */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-2" data-id="element-99">
                <p className="text-[9px] font-bold text-white leading-tight" data-id="element-100">
                  {palette.name}
                </p>
              </div>
            </motion.button>;
      })}
      </div>
    </div>;
}